export class Facture {
  public Ident: string;
  public StrNumFacture: string;
  public MontantHt: number;
  public MontantTTC: number;
  public RestantDu: number;

  public IdEntite: string;
  public IdClient: string;
  public TitreFacture: string;
  public StrDateFacture: string;
  public Email: string;
}
